var e = {
  isInitialized: !1,
  hasProductsError: !1,
  hasPickPostsError: !1,
  orderableProducts: [],
  availability: {},
  allPrescriptions: null,
  dailymedBoxes: null,
  pharmacies: null,
  pickPosts: null
}, l = (t) => ({
  setCheckoutInitData: (i) => t((a) => ({ checkoutInit: {
    ...a.checkoutInit,
    ...i
  } })),
  clearCheckoutInit: () => t({ checkoutInit: e })
});
export {
  l as createCheckoutInitActions,
  e as initialCheckoutInitState
};

//# sourceMappingURL=checkoutInit.action.js.map